import { useSidebar } from "@/components/ui/sidebar";
import { Button } from "@/components/ui/button";
import { Moon, Sun, LogOut, Menu } from "lucide-react";
import { useState, useEffect } from "react";
import { NotificationCenter } from "./NotificationCenter";

export default function DashboardHeader() {
  const { toggleSidebar } = useSidebar();
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const isDarkMode = document.documentElement.classList.contains('dark');
    setIsDark(isDarkMode);
  }, []);

  const toggleTheme = () => {
    const newTheme = !isDark;
    setIsDark(newTheme);
    if (newTheme) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  };

  const handleLogout = () => {
    window.location.href = '/api/logout';
  };

  return (
    <header className="flex items-center justify-between p-4 border-b bg-background">
      <Button
        variant="ghost"
        onClick={toggleSidebar}
        className="h-12 w-12 md:h-10 md:w-10 p-0 flex items-center justify-center [&_svg]:h-7 [&_svg]:w-7 md:[&_svg]:h-5 md:[&_svg]:w-5"
        aria-label="Toggle navigation menu"
        data-testid="button-sidebar-toggle"
      >
        <Menu />
      </Button>
      <div className="flex items-center gap-3">
        <NotificationCenter />
        <Button
          variant="ghost"
          size="icon"
          onClick={toggleTheme}
          data-testid="button-theme-toggle"
        >
          {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
        </Button>
        <Button
          variant="ghost"
          onClick={handleLogout}
          data-testid="button-logout"
        >
          <LogOut className="w-4 h-4 mr-2" />
          Logout
        </Button>
      </div>
    </header>
  );
}
